import { render, staticRenderFns, recyclableRender, components } from "./MoreBill.vue?vue&type=template&id=6605c068&"
var renderjs
import script from "./MoreBill.vue?vue&type=script&lang=js&"
export * from "./MoreBill.vue?vue&type=script&lang=js&"
import style0 from "./MoreBill.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/plus/assemble/detail/popup/MoreBill.vue"
export default component.exports